import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import SmsVerify from '@/views/_components/sms-verify/sms-verify.vue'
import { UserInfoEditService } from '@/views/dashboard/_components/central-control/_components/user-info-edit/user-info-edit.service'
import { ElMessage } from 'element-plus'
import { User, UserInfo } from '@/services/user'
import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'bind-phone',
  emits: ['update:modelValue', 'success'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const injector = useReflectiveInjector([UserInfoEditService])
const userInfoEditService = injector.get(UserInfoEditService)
const userService = injector.get(User)
const userInfo = reactive<Partial<UserInfo>>({})

userService.userInfo.subscribe(info => { Object.assign(userInfo, info) })

function confirmSmsVerify (data) {
  userInfoEditService.bindPhone({
    login_type: 4,
    mobile: {
      phone: data.phone,
      code: data.code
    }
  }).then(res => {
    ElMessage.success('绑定成功')
    userService.updateUserinfo({ ...userInfo, ...res.user_info })
    emits('success')
    handleClose()
  })
}

function handleClose () {
  emits('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SmsVerify, {
    "head-text": "绑定手机",
    "confirm-button-text": "确认",
    onConfirm: confirmSmsVerify,
    onClose: handleClose
  }))
}
}

})